module.exports = __webpack_public_path__ + "static/media/END CAP 45 MM BULL NOSE FOR 280 MM FOR CX.30353560.jpg";